<template>
  <div class="item-component">
    <div class="s-item-title">
      <h4 class="chart-title">
        <i class="el-icon-s-grid"></i>
        报到行程统计
      </h4>
    </div>
    <chart-five style="height: 90%" :value="chartData"></chart-five>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ChartFive from "../charts/chart05";
// import { chartData05 } from "@/assets/json/chartData";
export default {
  components: {
    ChartFive,
  },
  data() {
    return {
      chartData: [],
      enrollmentYear: "", // 入学年份
    };
  },
  computed: {
    ...mapState("dic", ["_CURRENTYEAR", "SUCCESS_CODE","_CURRENT_ACADEMIC"]),
  },
  created() {
    this.enrollmentYear = this._CURRENTYEAR[0].value;
    this.getStudentNum();
  },
  mounted() {},
  methods: {
    // 获取各院系新生人数(男女人数)
    getStudentNum() {
      let params = { enrollmentYear: this.enrollmentYear, academicDegree: this._CURRENT_ACADEMIC };
      this.$http
        .get("/welcome-forecast/transport/dateNum", { params })
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            // console.log(res);
            this.chartData = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
  },
};
</script>

<style>
</style>